import React from 'react';

const Consulta = () => {
  return <div>CONSULTA</div>;
};

export default Consulta;
